import { render, staticRenderFns } from "./visa_index.vue?vue&type=template&id=1d620369&scoped=true"
import script from "./visa_index.vue?vue&type=script&lang=js"
export * from "./visa_index.vue?vue&type=script&lang=js"
import style0 from "./visa_index.vue?vue&type=style&index=0&id=1d620369&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d620369",
  null
  
)

export default component.exports